import { buildReducer } from 'redux-keto'












const defaultEdgeServers = {
  infoServers: [],
  syncServers: []
}

export const contextConfig = buildReducer



({
  edgeServers(state = defaultEdgeServers, action) {
    if (action.type === 'INIT') {
      const { infoServers, syncServers } = action.payload
      return { infoServers, syncServers }
    }
    return state
  }
})
